export default __webpack_public_path__ + "static/media/cash-payment.fa1a101a.png";